import { useTranslation } from 'next-i18next'
import fabrice from 'assets/avatar-fabrice.webp'
import laura from 'assets/avatar-laura.webp'
import medhi from 'assets/avatar-medhi.webp'
import all from 'assets/company-all.webp'
import coupon from 'assets/company-coupon.webp'
import wonderbox from 'assets/company-wonderbox.webp'
import QuotesBlock from 'blocks/Quotes'

export function Quotes() {
  const { t } = useTranslation('home.page')

  return (
    <QuotesBlock
      title={t('quotes.title')}
      quotes={[
        {
          title: t('quotes.coupon.title'),
          author: t('quotes.coupon.author'),
          image: { image: laura, alt: t('quotes.coupon.author-alt') },
          logo: { image: coupon, alt: t('quotes.coupon.company-alt') },
        },
        {
          title: t('quotes.accor.title'),
          author: t('quotes.accor.author'),
          image: { image: medhi, alt: t('quotes.accor.author-alt') },
          logo: { image: all, alt: t('quotes.accor.company-alt') },
        },
        {
          title: t('quotes.wonderbox.title'),
          author: t('quotes.wonderbox.author'),
          image: { image: fabrice, alt: t('quotes.wonderbox.author-alt') },
          logo: { image: wonderbox, alt: t('quotes.wonderbox.company-alt') },
        },
      ]}
    />
  )
}
